import { useState, useEffect, useRef } from 'react'

export default function CustomSelect({ data }) {
	const [open, setOpen] = useState(false)
	const [selected, setSelected] = useState(null)
	const wrapperRef = useRef(null)

	const handleSelect = (item) => {
		setSelected(item)
		setOpen(false)
	}

	// tanca quan cliques fora
	useEffect(() => {
		const handleClickOutside = (e) => {
			if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
				setOpen(false)
			}
		}
		document.addEventListener('click', handleClickOutside)
		return () => {
			document.removeEventListener('click', handleClickOutside)
		}
	}, [])

	return (
		<section>
			<p className='e2'>On i quan firmen els autors?</p>

			<div className='custom-select-wrapper' ref={wrapperRef}>
				<div
					className={`custom-select ${open ? 'open' : ''}`}
					onClick={(e) => {
						e.stopPropagation()
						setOpen((prev) => !prev)
					}}
				>
					<div className='custom-select-input'>
						<input
							id='autors'
							tabIndex={-1}
							type='text'
							value={selected ? selected.id : ''}
							className={selected ? 'selected' : ''}
							readOnly
						/>
						<label htmlFor='autors'>Selecciona un autor</label>
						<span
							className='placeholder'
							data-value-focus='Selecciona un autor'
							data-value-default='Selecciona un autor'
						>
							{selected ? selected.autor : 'Selecciona un autor'}
						</span>
						<span className='arrow'>
							<svg viewBox='0 0 12 8' version='1.1' xmlns='http://www.w3.org/2000/svg'>
								<polygon points='1.41 0.59 6 5.17 10.59 0.59 12 2 6 8 0 2' />
							</svg>
						</span>
					</div>

					<div className='custom-options'>
						{data.data.map((item) => (
							<span
								key={item.id}
								className='custom-option'
								data-value={item.id}
								onClick={(e) => {
									e.stopPropagation()
									handleSelect(item)
								}}
							>
								{item.autor}
							</span>
						))}
					</div>
				</div>
			</div>

			{selected && (
				<div id='firmes'>
					<p className='e3'>{selected.autor}</p>
					<p className='e4'>
						{selected.titol}, {selected.editorial.nom}
					</p>
					<ul>
						{selected.firmes.map((firma, i) => (
							<li key={i}>
								<p className='e3'>{firma.hora}</p>
								<p className='e4'>
									<span>{firma.lloc}</span> — {firma.direccio}
								</p>
							</li>
						))}
					</ul>
				</div>
			)}
		</section>
	)
}
